import { MoonIcon, SunIcon } from '@heroicons/react/24/outline';
import { PropType, cn } from '@theprintbar/shared';
import { useState } from 'react';
import { BrandPattern } from '../IdentityComponents';
import { Toggle } from '../Toggle';

interface PatternImageProps extends Partial<PropType<typeof BrandPattern>> {
	className?: string;
	containerClass?: string;
	children: React.ReactNode;
	tight?: boolean;
	toggleDark?: boolean;
}

export function PatternImage({
	className,
	children,
	containerClass,
	bgClass,
	patternClass,
	pattern,
	tight,
	toggleDark,
	...brandProps
}: PatternImageProps) {
	const [isDark, setDark] = useState(false);
	//If it's tight we want to grid the pattern in 2 columns 2 rows
	const bg = (
		<img
			src="/images/bg.webp"
			role="presentation"
			alt="Sparkle background"
			className={cn('absolute h-full w-full object-cover object-left-top bg-white-mid', patternClass)}
		/>
	);
	return (
		<div className={cn('relative w-full h-full', className)}>
			{tight ? (
				<div className="absolute inset-0 grid grid-cols-2 grid-rows-2 h-full w-full">
					<div className="relative h-full w-full">{bg}</div>
					<div className="relative h-full w-full">{bg}</div>
					<div className="relative h-full w-full">{bg}</div>
					<div className="relative h-full w-full">{bg}</div>
				</div>
			) : (
				bg
			)}
			{isDark && <div className="absolute h-full w-full bg-black/50" />}

			<div className={cn('absolute h-full w-full', containerClass)}>{children}</div>
			{toggleDark && (
				<div className="absolute top-2 right-2">
					<Toggle
						enabled={isDark}
						onChange={setDark}
						enabledIcon={MoonIcon}
						className="bg-gray-100 border-grey"
						enabledClassName="bg-gray-600 border-gray-100"
						disabledIcon={SunIcon}
					/>
				</div>
			)}
		</div>
	);
}
